import { MinusCircleOutlined, PlusCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Select, Spin, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import moment from 'moment';
import dayjs from 'dayjs';
import liracrypt from '../components/Liracrypt/liracrypt';
import ZenFormInput from './InputCreater/ZenFormInput';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import StablePrime from '../components/Tables/StablePrime';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';

const ProductionReport = ({
    setPageHeader,
    pageName,
    className
}) => {
    setPageHeader(pageName);
    const { search } = useLocation();
    const [loading, setLoading] = useState(false);
    const [tblData, setTblData] = useState();
    const searchParams = queryString.parse(search);
    const [rowCount, setRowCount] = useState(1);
    const [form] = Form.useForm();
    const [formData, setFormData] = useState();
    const [latestToValue, setLatestToValue] = useState();
    const [slotDropdown, setSlotDropdown] = useState([
        { label: '0', value: 0 },
        { label: '1', value: 1 },
    ]);
    useEffect(() => {
        let initialValue = [
            { from: '06:00', to: '07:00', dur: '60', typ: 'Run', shift: 'A', slot: 0 }
        ]
        form.setFieldsValue({ ['production']: initialValue });
        let currentDate = moment().set({
            hours: '07',
            minutes: '00',
            seconds: '00',
            millisecond: '00'
        });
        setLatestToValue(currentDate)
    }, []);

    const is24Hours = () => {
        let formValues = form.getFieldValue('production');
        let totalDuration = 0;
        formValues.forEach(x => {
            totalDuration += parseInt(x.dur);
        });
        if (totalDuration === 1440 || totalDuration > 1440) { return true } else { return false }
    }

    const addNewRow = () => {
        if (is24Hours()) return;
        let tomorrow = moment().add(1, 'days').set({
            hours: '00',
            minutes: '00',
            seconds: '00',
            millisecond: '00'
        });
        let formValues = form.getFieldValue('production');
        let currentRowValue = formValues[rowCount - 1];
        if (parseInt(currentRowValue.dur) > 60) return message.error('Duration should not be greater than 60');
        let emptyValue = Object.values(currentRowValue).filter(x => x === '' || x === null || x === undefined);
        if (emptyValue.length) return message.error('Please fill all the values correctly', 3);
        let difference = latestToValue.diff(tomorrow, 'm', true);
        difference = Math.ceil(difference);
        if (difference > 0) {
            formValues[rowCount - 1].to = '00:00';
            formValues[rowCount - 1].dur = parseInt(currentRowValue.dur) - (difference);
            formValues.push({
                from: '00:00',
                to: `00:${difference.toString().padStart(2, '0')}`,
                dur: (difference).toString(),
                slot: currentRowValue.slot,
                typ: currentRowValue.typ,
                shift: currentRowValue.shift,
            });
            const toValue = moment().set({
                hours: '00',
                minutes: `00:${difference.toString().padStart(2, '0')}`,
                seconds: '00',
                millisecond: '00'
            })
            setLatestToValue(toValue);
        } else {
            let toVal = moment().set({
                hours: currentRowValue.to.split(':')[0],
                minutes: currentRowValue.to.split(':')[1],
                seconds: '00',
                millisecond: '00'
            }).add('60', 'minutes');
            formValues.push({
                from: currentRowValue.to,
                to: toVal.format('HH:mm'),
                dur: '60',
                typ: 'Run',
                slot: currentRowValue.slot,
                shift: 'A'
            });
        }
        setSlotDropdown([
            { label: currentRowValue.slot?.toString(), value: currentRowValue.slot },
            { label: (currentRowValue.slot + 1).toString(), value: (currentRowValue.slot + 1) }
        ])
        form.setFieldsValue({ ['production']: formValues });
        setRowCount(rowCount + 1);
    }

    const onDurationChange = debounce(({ value, index }) => {
        let formValues = form.getFieldValue('production');
        let currentRowValue = formValues[index];
        const toValue = moment().set({
            hours: currentRowValue.from.split(':')[0],
            minutes: currentRowValue.from.split(':')[1],
            seconds: '00',
            millisecond: '00'
        }).add(value, 'minutes');
        setLatestToValue(toValue);
        currentRowValue.to = toValue.format('HH:mm');
        formValues[index] = currentRowValue;
        form.setFieldsValue({ ['production']: formValues })
    }, 500);

    const deleteRow = () => {
        let formValues = form.getFieldValue('production');
        formValues = formValues.filter((_, i) => i !== (formValues.length - 1));
        let currentRowValue = formValues[formValues.length - 1];
        const toValue = moment().set({
            hours: currentRowValue.from.split(':')[0],
            minutes: currentRowValue.from.split(':')[1],
            seconds: '00',
            millisecond: '00'
        })
        setLatestToValue(toValue);
        form.setFieldsValue({ ['production']: formValues });
        setRowCount(rowCount - 1);
    }

    const onFinish = (values) => {
        if (!is24Hours()) return message.error('Please complete 24 hours cycle');
        let totalMinutes = 0;
        values.production.forEach(x => {
            totalMinutes += parseInt(x.dur);
        });
        if (totalMinutes !== 1440) {
            message.error('Total Duration should not be less than or greater than 24 hours');
            return;
        };
        setLoading(true);
        liracrypt.post('/masterdata/prodnslot', { ...values, ...searchParams })
            .then(response => {
                setTblData(response.data);
                setLoading(false);
            }).catch(err => {
                ApiErrorComp();
                console.log(err);
            })
    }

    return (
        <div className={`AuditSection CreateAudit`} style={{ padding: "10px" }}>
            <div className={`ThemeForm ${className || 'phantom'}-form`}>
                <Form form={form} name="ProductionReportSlot" size="large" onFinish={onFinish}>
                    <Row justify={"center"} style={{ marginBottom: 20 }}>
                        <Col span={12}>
                            <ZenFormInput
                                form={form}
                                name={'breakZone'}
                                pname={'p_breakzone'}
                                typ="dropDown"
                                source={"mdict"}
                                sourceParams={{ typ: 'Breakzone', subTyp: 'idame' }}
                                label="BreakZone"
                                required={true}
                                data={{}}
                            />
                        </Col>
                    </Row>

                    {
                        Array.from({ length: rowCount }).map((_, i) => (
                            <Row key={'production-report-slot' + i}>
                                <Col span={3}>
                                    <Form.Item label="From" name={['production', i, 'from']} rules={[{ required: true, message: 'This field is required' }]}>
                                        <Input type='text' disabled style={{ height: 40 }} />
                                    </Form.Item>
                                </Col>
                                <Col span={3}>
                                    <Form.Item label="To" name={['production', i, 'to']} shouldUpdate rules={[{ required: true, message: 'This field is required' }]}>
                                        <Input type='text' disabled style={{ height: 40 }} />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item label="Dur" name={['production', i, 'dur']} rules={[
                                        { required: true, message: 'This field is required' }
                                    ]}>
                                        <Input
                                            disabled={(i + 1) !== rowCount}
                                            type='number'
                                            onChange={(e) => onDurationChange({ value: e.target.value, index: i })}
                                            style={{ height: 40 }}
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item label="Typ" name={['production', i, 'typ']} rules={[{ required: true, message: 'This field is required' }]}>
                                        <Select
                                            options={[
                                                { label: 'Run', value: 'Run' },
                                                { label: 'Break', value: 'Break' },
                                            ]}
                                            placeholder="Please Select"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item label="Shift" name={['production', i, 'shift']} rules={[{ required: true, message: 'This field is required' }]}>
                                        <Select
                                            options={[
                                                { label: 'Shift A', value: 'A' },
                                                { label: 'Shift B', value: 'B' },
                                                { label: 'Shift C', value: 'C' },
                                            ]}
                                            placeholder="Please Select"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <Form.Item label="slot" name={['production', i, 'slot']} rules={[{ required: true, message: 'This field is required' }]}>
                                        <Select
                                            disabled={(i === 0 || (i + 1) !== rowCount)}
                                            options={slotDropdown}
                                            placeholder="Please Select"
                                        />
                                    </Form.Item>
                                </Col>
                                {
                                    (i + 1) === rowCount && (
                                        <Col span={2}>
                                            <div>
                                                <Button
                                                    onClick={addNewRow}
                                                    type="link" icon={
                                                        <PlusCircleOutlined />
                                                    }>{''}</Button>
                                                {
                                                    rowCount > 1 && (
                                                        <Button
                                                            onClick={() => deleteRow()}
                                                            type="link" icon={
                                                                <MinusCircleOutlined />
                                                            }>{''}</Button>
                                                    )
                                                }

                                            </div>

                                        </Col>
                                    )
                                }
                            </Row>
                        ))
                    }
                    <div style={{ margin: 20, width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <Button htmlType='submit' type="primary">
                            Submit
                        </Button>
                    </div>
                </Form>
            </div>

            {
                loading ?
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 60 }} />} />
                    </div>
                    :
                    tblData ?
                        <StablePrime tableData={tblData} /> : <></>
            }
        </div>
    )
};

export default ProductionReport;